<script setup>
import { ref } from 'vue';

const props = defineProps([
    'label',
    'name',
    'id',
    'text',
    'maxFileSizeText'
]);
const emit = defineEmits(['updateFiles']);

const fileInput = ref(null);
const filesList = ref([]);

const handleChange = (e) => {
    const newFiles = Array.from(e.target.files);

    newFiles.forEach(file => {
        if (validation(file)) {
            filesList.value.push(file);
        }
    });

    // Emit the files to the parent component
    emit('updateFiles', filesList.value);

    // Store files in the global window.uploadedFiles variable
    window.uploadedFiles = filesList.value;

    // Clear input to allow re-upload of the same file if removed
    fileInput.value.value = "";
};

const removeFile = (index) => {
    filesList.value.splice(index, 1);
    emit('updateFiles', filesList.value); // Emit updated files list

    // Update the global variable when files are removed
    window.uploadedFiles = filesList.value;
};

const validation = (file) => {
    const maxSize = 1048576; // 1MB

    if (file.size > maxSize) {
        window.alert(props.maxFileSizeText);
        return false;
    }
    return true;
};
</script>

<template>
    <div class="input-holder">
        <label v-html="label"></label>
        <div class="c-file-input js-file-input">
            <input type="file" :name="name" :id="id" ref="fileInput" multiple @change="handleChange">
            <div class="c-file-input__inner">
                <svg width="27px" height="26px">
                    <use href="/img/icons/icons.svg#upload"></use>
                </svg>
                <p>{{ text }}</p>
            </div>
        </div>

        <ul v-if="filesList.length > 0" class="file-list">
            <li v-for="(file, index) in filesList" :key="index">
                {{ file.name }}
                <button type="button" @click="removeFile(index)" class="file-remove-btn">
                    <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 6L18 18M18 6L6 18" stroke="#D62828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </li>
        </ul>
    </div>
</template>
